import { render, staticRenderFns } from "./NoDeleteBox.vue?vue&type=template&id=31625c4f&scoped=true&"
import script from "./NoDeleteBox.vue?vue&type=script&lang=js&"
export * from "./NoDeleteBox.vue?vue&type=script&lang=js&"
import style0 from "./NoDeleteBox.vue?vue&type=style&index=0&id=31625c4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31625c4f",
  null
  
)

export default component.exports